import {CartItem} from '../../data/model';

export function buildCartItemSpecLabel(item: CartItem): string {
  if (item.quote) {
    return '';
  }

  const specNames: string[] =
    item.specs && item.specs.length > 0
      ? item.specs.map(spec => spec.value)
      : item.variant?.name
        ? item.variant.name.split(', ')
        : [];

  return specNames.map(formatCartItemSpecValue).filter(Boolean).join(' • ');
}

function formatCartItemSpecValue(value: string): string {
  const trimmedValue = value.trim();
  if (!trimmedValue) {
    return '';
  }

  return trimmedValue.replace(/[A-Za-z]+/g, word => {
    if (/[a-z]/.test(word) && /[A-Z]/.test(word)) {
      return word;
    }

    if (word === word.toUpperCase() && word.length <= 3) {
      return word;
    }

    const lowerCasedWord = word.toLowerCase();
    return lowerCasedWord.charAt(0).toUpperCase() + lowerCasedWord.slice(1);
  });
}
